import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLocale, loadLocaleMessages } from '../locales'

Vue.use(VueI18n)

const locale = getLocale()

export default new VueI18n({
  locale,
  fallbackLocale: 'de',
  messages: {
    de: loadLocaleMessages('de'),
    en: loadLocaleMessages('en')
  },
  silentTranslationWarn: true,
  pluralizationRules: {
    'en': (choice) => choice === 1 ? 0 : 1,
    'de': (choice) => choice === 1 ? 0 : 1
  },
  dateTimeFormats: {
    de: {
      short: { year: 'numeric', month: '2-digit', day: '2-digit' },
      long: { year: 'numeric', month: 'long', day: 'numeric' }
    },
    en: {
      short: { year: 'numeric', month: '2-digit', day: '2-digit' },
      long: { year: 'numeric', month: 'long', day: 'numeric' }
    }
  },
  numberFormats: {
    de: {
      decimal: { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 },
      currency: { style: 'currency', currency: 'EUR' }
    },
    en: {
      decimal: { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 },
      currency: { style: 'currency', currency: 'EUR' }
    }
  }
})
